<div class="btncontainer">
  <button #btn2 id="btn2" (click)="printPageWithDiffrentCss()" class="btn">
    Click here to print
  </button>
</div>
<!-- Header -->
<div class="newbody">
  <div [ngSwitch]="whichPage">
    <div *ngSwitchCase="20">
      <app-prescription-header></app-prescription-header>
    </div>
    <div *ngSwitchDefault></div>
  </div>

  <!-- body -->
  <div [ngSwitch]="whichPage">
    <div *ngSwitchCase="20">
      <app-prescription-body></app-prescription-body>
    </div>

    <div *ngSwitchDefault>
      <div class="container mw-100">
        <h2>Page not Found</h2>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div [ngSwitch]="whichPage">
    <div *ngSwitchCase="20">
      <app-prescription-footer></app-prescription-footer>
    </div>
    <div *ngSwitchDefault></div>
  </div>
</div>
